import { useCallback, useMemo, useState } from "react"
import { useSubscription } from "react-relay"
import { graphql, GraphQLSubscriptionConfig } from "relay-runtime"
import {
  useOnHasUnreadMessagesChangedSubscription$data,
  useOnHasUnreadMessagesChangedSubscription as useOnHasUnreadMessagesChangedSubscriptionType,
} from "@/modules/chats/services/__generated__/useOnHasUnreadMessagesChangedSubscription.graphql"

const subscription = graphql`
  subscription useOnHasUnreadMessagesChangedSubscription {
    onHasUnreadMessagesChanged {
      hasUnreadMessages
    }
  }
`

export const useOnHasUnreadMessagesChangedSubscription = () => {
  const [hasUnreadMessages, setHasUnreadMessages] = useState(false)

  const handleNext = useCallback((response: useOnHasUnreadMessagesChangedSubscription$data | null | undefined) => {
    const event = response?.onHasUnreadMessagesChanged
    if (!event) return
    setHasUnreadMessages(event.hasUnreadMessages)
  }, [])

  const config: GraphQLSubscriptionConfig<useOnHasUnreadMessagesChangedSubscriptionType> = useMemo(
    () => ({
      subscription,
      variables: {},
      onNext: handleNext,
      onError: console.log,
      cacheConfig: { metadata: { sensitive: true } },
    }),
    [handleNext],
  )

  useSubscription<useOnHasUnreadMessagesChangedSubscriptionType>(config)

  return hasUnreadMessages
}
